module.exports = __webpack_public_path__ + "static/media/onboarding_tour_slide2.efafa6aa.png";